import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatProgress = createCustomElementWrapper('kat-progress', 'KatProgress', {
    'endValue': 'end-value',
    'hideValue': 'hide-value',
    'katAriaLabel': 'kat-aria-label',
    'startValue': 'start-value',
}, {}, [
    'label',
]);
